module.exports = __webpack_public_path__ + "static/media/aboutus-details.0ffd4214.jpg";